import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

export interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  value: string;
  onBlur: (value: string) => void;
}

const PhoneNumberMask = forwardRef<HTMLElement, CustomProps>(function PhoneMask(
  props,
  _ref
) {
  const { onChange, onBlur, ...other } = props;
  const formattedValue = props.value ? props.value.replace('+1', '') : '';
  return (
    <IMaskInput
      {...other}
      mask="(000) 000-0000"
      value={formattedValue}
      onBlur={() => {
        onChange({ target: { name: props.name, value: props.value } });
        if (onBlur) onBlur(props.value);
      }}
      onAccept={(rawValue: any) => {
        const updatedValue = '+1' + rawValue.replace(/[\(\) -]/g, '');
        if (props.value !== updatedValue) {
          onChange({ target: { name: props.name, value: updatedValue } });
        }
      }}
      overwrite
    />
  );
});

export default PhoneNumberMask;
